import React from "react";

function Home() {
  return (
    <div>
     
<section className="ftco-section testimony-section">
    <div className="container">
      <div className="row mb-5 pb-3 mx-auto">
        <div className="col-md-3"></div>
        <div className="col-md-7 heading-section ftco-animate fadeInUp ftco-animated">
            {/* <span className="subheading">Testimony</span> */}
          <h2 style={{color:"#3A3A3A"}}><b>Excellence From Insight</b></h2>
         <div style={{color:"#5E5550"}}>
          <p>
            Entering the 21st Century, Nabeel Saeed Law Firm is constantly redefining itself to be in sync with the economy of our times. With a mission statement that reflects the Firm's commitment as an empathetic entity, first and foremost, and a professional legal team, the Firm has established superior standards for all its work to ensure the delivery of quality results with a responsiveness to the business priorities and legal needs of all clients
            </p>
            <p>
            Nabeel Saeed Law Firm is a boutique law firm based in the Kingdom of Bahrain and offering personalized legal services in all areas of law including the areas of Corporate, Banking (both Islamic and Conventional) Construction, Contract Law and Dispute Resolution on behalf of Corporations, Banks, High Net Worth Individuals and well known Business Families. While its primary focus is Commercial Law, mainly Corporate and Banking, the Firm engages in legal services covering all areas of law including advising and counselling clients on their rights and duties under state and local laws. 
            </p>
            <p>
            Nabeel Saeed Law Firm is made up of skilled lawyers who interact with one another on a daily basis, sharing their collective expertise and comprehension of a variety of legal issues all to deliver the necessary solutions to their clients. Their knowledge of the local laws and customs draws the team together in both productivity and professionalism allowing them to successfully execute the standard of work the firm aspires to.  
  Languages spoken in the firm include English and Arabic
            </p>
         </div>
        </div>
        <div className="col-md-2"></div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Home;
